<script>
import Form from "../Form.vue";
import * as categoryService from "../../service/category.service";
import _ from "lodash";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    setTopbarControls: {
      type: Function,
      required: false,
    },
    topbarControls: {
      type: Object,
      required: false,
    },
    updateSelectedItem: {
      type: Function,
      required: false,
    },
  },
  components: {
    Form,
  },
  data() {
    return {
      selectedItem: new Object(),
      dataValue: new Object(),
      prevSelectedItem: "{}",
    };
  },
  computed: {},
  methods: {
    setSelectedItems(val) {
      console.log("setSelectedItems called", val);
      this.selectedItem = val;
      this.dataValue = this.updtaeAdditionPropValue(val);
      this.prevSelectedItem = JSON.stringify(val);
      this.setTopbarControls(
        null,
        null,
        this.selectedItem,
        this.prevSelectedItem
      );
    },
    updtaeAdditionPropValue(dataObject) {
      Object.keys(dataObject.additionalProp1).forEach((key) => {
        if (_.has(dataObject, key)) {
          dataObject[key] = dataObject.additionalProp1[key];
        }
      });
      return dataObject;
    },
    async getData() {
      const data = await categoryService.get(this.$route.params.categoryId);
      // let clonedObject = _.clone(data);

      // let modifiedData = this.removeDuplicateKeys(clonedObject);
      // console.log("this.conditionalRemoveKey(data)", modifiedData);

      this.setSelectedItems(data);
    },
  },

  async mounted() {
    await this.getData();
  },
};
</script>
<template>
  <Form
    :style="item.form.style"
    :class="`col-${item.form.size} ${item.form.class}`"
    :form="item.form.form"
    :variant="item.form.variant"
    :data="dataValue"
    :topbarControls="topbarControls"
    :selectedItem="selectedItem"
    :setSelectedItems="setSelectedItems"
    :updateSelectedItem="updateSelectedItem"
  />
</template>

<style scoped>
.simplebar-custom {
  max-height: calc(100vh - 300px);
  padding-right: 2em;
}
</style>
